import { ISearchCity } from 'meta/pages/search'
import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequest } from 'utils/http'

export const findCities = async (params: { name: string }): Promise<Array<ISearchCity>> => {
  const { name } = params
  const { data } = await HttpRequest.get<{ cities: Array<ISearchCity> }>(ApiEndpoint.search.findCities(name))
  return data.cities
}
